import type { JSX } from 'preact';
import { glance } from '../content/wedding';

type IconName = (typeof glance)[number]['icon'];

/**
 * Hairline drawings for the at-a-glance strip. Kept to a single 1px stroke and
 * no fills so they sit in the same engraved language as the vine and the rules
 * — an icon set with weight to it would read as clip art here.
 */
const ICONS: Record<IconName, JSX.Element> = {
  // Bow tie: two wings meeting at a knot.
  attire: (
    <>
      <path d="M13 8 L3 3.5 v13 L13 12" />
      <path d="M15 8 L25 3.5 v13 L15 12" />
      <rect x="12.4" y="6.6" width="3.2" height="6.8" rx="0.6" />
    </>
  ),
  // The same lanceolate leaf the vine is drawn from.
  leaf: (
    <>
      <path d="M3 18 C 7.5 3.5, 19.5 1, 25 2 C 24.5 10, 16 18, 3 18 Z" />
      <path d="M3 18 C 9.5 13.5, 15 9.5, 22.5 4.5" />
    </>
  ),
  // Hands at a legible right angle rather than the literal time — at 28px two
  // near-collinear hands read as a line struck through a circle, not a clock.
  clock: (
    <>
      <circle cx="14" cy="10" r="8.4" />
      <path d="M14 10.4 L14 4.8" />
      <path d="M14 10 L18.3 10" />
    </>
  ),
};

export function Glance() {
  return (
    <div class="glance">
      {glance.map((item) => (
        <div class="glance__item" key={item.label}>
          <svg
            class="glance__icon"
            viewBox="0 0 28 20"
            fill="none"
            stroke="currentColor"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
            vector-effect="non-scaling-stroke"
            aria-hidden="true"
          >
            {ICONS[item.icon]}
          </svg>
          <p class="glance__label">{item.label}</p>
          <p class="glance__value">{item.value}</p>
          <p class="glance__note">{item.note}</p>
        </div>
      ))}
    </div>
  );
}
